window.addEventListener('DOMContentLoaded', function() {
    // 要素の数
    const listItems = document.querySelectorAll('.js-blog-more .blog-list__card, .js-blog-more .news__list, .js-blog-more .brand-push__item');
    // MOREボタン
    const btnMore = document.querySelector('.js-btn-more');
    // 最初に表示させる数
    let num = 20;

    if (listItems.length > 0 && btnMore !== null) {
        // コードを実行する処理を記述
        if (num >= listItems.length) {
            btnMore.style.display = 'none';
        }
        
        // 最初に表示させるliの数
        for (let i = 0; i < listItems.length; i++) {
            // num以上はdisplay:none;
            if (i >= num) {
                listItems[i].style.display = 'none';
            }
        }
        
        // ボタンをクリックしたら
        btnMore.addEventListener('click', function() {
            // 追加する数
            num += 18;
            for (let i = 0; i < listItems.length; i++) {
                if (i < num) {
                    listItems[i].style.display = 'block';
                } else {
                    listItems[i].style.display = 'none';
                }
            }
            
            if (num >= listItems.length) {
                btnMore.style.display = 'none';
            }
        });
    } else if (btnMore !== null) {
        btnMore.style.display = 'none';
    }
});